/**
 * Lazy load scripts on pages that have appropriate element
 */
export default class LazyLoadScript {
  private scriptLink: string;

  constructor(elem: string, source: string) {
    let element = $(elem);

    if (element.length !== 0) {
      let s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;

      if (elem === '.g-recaptcha') {
        this.addLanguage(source);
      } else {
        this.scriptLink = source;
      }

      s.src = this.scriptLink;
      $('body').append(s);
    }
  }

  addLanguage(source: string) {
    let lang = $('html').attr('lang');

    this.scriptLink = source + lang;
  }
}
